module.exports = __webpack_public_path__ + "static/media/bottle_ink_white.98ebcaf8.svg";